import React, { useState } from 'react';
import { useProfile } from '../hooks/UserHooks';

const Navdata = () => {
    const { userProfile } = useProfile();
    const [isEntrega, setIsEntrega] = useState<boolean>(false);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [isInventario, setIsInventario] = useState<boolean>(false);
    const [isProtecoes, setIsProtecoes] = useState<boolean>(false);
    const [isSuporte, setIsSuporte] = useState<boolean>(false);
    const [isApiKeys, setIsApiKeys] = useState<boolean>(false);
    const [isDashboard, setIsDashboard] = useState<boolean>(false);
    const [isCompany, setIsCompany] = useState<boolean>(false);
    const [isIntegrations, setIsIntegrations] = useState<boolean>(false);

    // Helper function to check if user has required role
    const hasRole = (allowedRoles: string[] = []) => {
        if (!allowedRoles.length) return true; // No role restriction
        return allowedRoles.includes(userProfile?.role || '');
    };

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute('sub-items')) {
            const ul: any = document.getElementById('two-column-menu');
            const iconItems: any = ul.querySelectorAll('.nav-icon.active');
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove('active');
                const id = item.getAttribute('sub-items');
                const getID = document.getElementById(id) as HTMLElement;
                if (getID)
                    getID.classList.remove('show');
            });
        }
    }

    const menuItems: any = [
        {
            label: '',
            isHeader: true,
        },
        {
            id: 'dashboard',
            label: 'Dashboard',
            icon: 'ri-dashboard-line',
            link: '/#',
            stateVariables: isDashboard,
            roles: [], // Available to all roles
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                updateIconSidebar(e);
            },
        },
        {
            id: 'company',
            label: 'Empresas',
            icon: 'ri-home-2-line',
            link: '/#',
            stateVariables: isCompany,
            roles: ['ROLE_SUPER_ADMIN', 'ROLE_AGENCY_ADMIN', 'ROLE_AD_NETWORK_ADMIN'],
            click: function (e: any) {
                e.preventDefault();
                setIsCompany(!isCompany);
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: 'ad-network',
                    label: 'Ad Networks',
                    link: '/ad-network',
                    roles: ['ROLE_SUPER_ADMIN'],
                },
                {
                    id: 'advertiser',
                    label: 'Anunciantes',
                    link: '/advertiser',
                    roles: ['ROLE_SUPER_ADMIN'],
                },
                {
                    id: 'agency',
                    label: 'Agências',
                    link: '/agency',
                    roles: ['ROLE_SUPER_ADMIN'],
                },
                {
                    id: 'publisher',
                    label: 'Publishers',
                    link: '/publisher',
                    roles: ['ROLE_SUPER_ADMIN', 'ROLE_AGENCY_ADMIN', 'ROLE_AD_NETWORK_ADMIN'],
                },
            ],
        },
        {
            id: 'delivery',
            label: 'Entrega',
            icon: 'ri-truck-line',
            link: '/#',
            stateVariables: isEntrega,
            roles: [], // Available to all roles
            click: function (e: any) {
                e.preventDefault();
                setIsEntrega(!isEntrega);
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: 'campaign',
                    label: 'Campanhas',
                    link: '/campaign',
                    roles: [],
                },
                {
                    id: 'order',
                    label: 'Pedidos',
                    link: '/order',
                    roles: [],
                },
                {
                    id: 'creative',
                    label: 'Criativos',
                    link: '/creative',
                    roles: [],
                },
            ],
        },
        {
            id: 'inventory',
            label: 'Inventário',
            icon: 'ri-pages-line',
            link: '/#',
            stateVariables: isInventario,
            roles: ['ROLE_SUPER_ADMIN', 'ROLE_AD_NETWORK_ADMIN', 'ROLE_PUBLISHER_ADMIN'],
            click: function (e: any) {
                e.preventDefault();
                setIsInventario(!isInventario);
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: 'site',
                    label: 'Sites',
                    link: '/site',
                    roles: [],
                },
                {
                    id: 'placement',
                    label: 'Blocos de anúncios',
                    link: '/placement',
                    roles: ['ROLE_SUPER_ADMIN'],
                },
                {
                    id: 'tags',
                    label: 'TAGs',
                    link: '/tag',
                    roles: [],
                },
            ],
        },
        {
            id: 'protections',
            label: 'Brand Safety',
            icon: 'ri-shield-line',
            link: '/#',
            stateVariables: isProtecoes,
            roles: [], // Available to all roles
            click: function (e: any) {
                e.preventDefault();
                setIsProtecoes(!isProtecoes);
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: 'blocked-keywords',
                    label: 'Palavras-chave',
                    link: '/blocked-keywords',
                    roles: [],
                },
            ],
        },
        {
            id: 'integrations',
            label: 'Integrações',
            icon: 'ri-plug-line',
            link: '/integrations',
            stateVariables: isIntegrations,
            roles: [], // Available to all roles
            click: function (e: any) {
                e.preventDefault();
                setIsIntegrations(!isIntegrations);
                updateIconSidebar(e);
            },
        },
        {
            id: 'admin',
            label: 'Admin',
            icon: 'ri-admin-line',
            link: '/#',
            stateVariables: isAdmin,
            roles: [], // Available to all roles (but subitems have restrictions)
            click: function (e: any) {
                e.preventDefault();
                setIsAdmin(!isAdmin);
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: 'user',
                    label: 'Usuários',
                    link: '/user',
                    parentId: 'admin',
                    roles: [],
                },
                {
                    id: 'audit-log',
                    label: 'Histórico de alterações',
                    link: '/audit-log',
                    parentId: 'admin',
                    roles: ['ROLE_SUPER_ADMIN'],
                },
            ],
        },
        {
            id: 'api_keys',
            label: 'Api Keys',
            icon: 'ri-key-2-line',
            link: '/api-keys',
            stateVariables: isApiKeys,
            roles: ['ROLE_SUPER_ADMIN', 'ROLE_AGENCY_ADMIN', 'ROLE_AD_NETWORK_ADMIN'],
            click: function (e: any) {
                e.preventDefault();
                setIsApiKeys(!isApiKeys);
                updateIconSidebar(e);
            },
        },
        {
            id: 'wiki',
            label: 'Wiki',
            icon: 'ri-book-line',
            link: 'https://help.adpulse.com.br',
            target: '_blank',
            stateVariables: false,
            roles: [], // Available to all roles
        },
        {
            id: 'suporte',
            label: 'Suporte',
            icon: 'ri-question-mark',
            link: '/support',
            stateVariables: isSuporte,
            roles: ['ROLE_SUPER_ADMIN', 'ROLE_AGENCY_ADMIN', 'ROLE_AD_NETWORK_ADMIN'],
            click: function (e: any) {
                e.preventDefault();
                setIsSuporte(!isSuporte);
                updateIconSidebar(e);
            },
        },
    ];

    // Add impersonation exit option if user is impersonating
    if (typeof userProfile?.impersonatedUser === 'object') {
        menuItems.push({
            id: 'exit-impersonation',
            label: 'Sair da personificação',
            icon: 'ri-user-received-line',
            link: '/exit-impersonation',
            roles: [], // Available to all roles when impersonating
            click: function (e: any) {
                e.preventDefault();
            },
        });
    }

    // Filter menu items based on user roles
    const filterMenuByRole = (items: any[]) => {
        return items.filter((item) => {
            if (item.isHeader) return true; // Always show headers

            // Check if user has access to this menu item
            if (!hasRole(item.roles)) return false;

            // Filter subitems if they exist
            if (item.subItems) {
                item.subItems = item.subItems.filter((subItem: any) => hasRole(subItem.roles));
                // Hide parent menu if no subitems are accessible
                if (item.subItems.length === 0) return false;
            }

            return true;
        });
    };

    const filteredMenuItems = filterMenuByRole(menuItems);

    return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};
export default Navdata;